// Mirrors isUnauthorizedError's narrow reading: 403 is a real access denial for a signed-in user,
// not a session expiry, so it cannot recover without new access. fetchBaseQuery reports an HTTP
// failure as { status: <number>, data: unknown }; network failures carry a string status and stay
// pollable.
export function permanentHttpDenial(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) return false
  const status = (error as { status?: unknown }).status
  return status === 401 || status === 403
}
